import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query BillingInvoices($businessId: ID!) {
    billingZuoraInvoices(businessId: $businessId) {
      invoices {
        invoiceId
        businessID
        invoiceNumber
        currency
        amount
        balance
        type
        invoiceDate
        dueDate
      }
    }
  }
`

export const billingZuoraInvoicesKey = getQueryNames(query)[0]

export default query
